export default __webpack_public_path__ + "static/media/bg_main_about2.5bcf72ec.png";